import type * as React from "react";
export const BackwardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={20}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.1999 19.1978C23.2087 19.1978 23.2153 19.1978 23.224 19.1978C23.5259 19.1847 23.7643 18.9353 23.7599 18.6334C23.7578 18.4956 23.4362 5.02063 10.32 4.64875V0.72C10.32 0.503437 10.1953 0.306563 10.0006 0.214687C9.80812 0.120625 9.574 0.149063 9.40781 0.284687L0.447812 7.56469C0.3165 7.67188 0.24 7.83156 0.24 8C0.24 8.16844 0.3165 8.32812 0.445625 8.43531L9.40562 15.7153C9.574 15.8509 9.80594 15.8772 10.0006 15.7853C10.1953 15.6934 10.32 15.4966 10.32 15.28V11.3644C21.9903 11.5766 22.6203 18.3841 22.6421 18.6772C22.6618 18.9725 22.9068 19.1978 23.1999 19.1978Z"
      fill="currentColor"
    />
  </svg>
);
